import { useEffect, useRef, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronDown, faShareNodes } from "@fortawesome/free-solid-svg-icons";
import "./PlayerBreadcrumb.scss";
import { Button, ButtonType } from "components/Button/Button";
import ShareModal from "components/ShareModal/ShareModal"
import { ModalButtons } from 'components/Modal/ModalButtons';
import { useModal } from 'components/Modal/context/ModalContext';
import { MOBILE_WIDTH } from "utils/constants";

const PlayerBreadcrumb = ({ course, module, submodule, setBreadcrumbHeight }) => {
	const breadcrumbRef = useRef(null);
	const { openModal } = useModal();
	const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_WIDTH);
	const [expanded, setExpanded] = useState(false);

	const buildLink = () => {
		return `/player#courseId-${course.Id}-moduleId-${module.Id}-submoduleId-${submodule.Id}`;
	};

	const handleOpenShareModal = ({ shareLink }) => {
		openModal("Share", <ShareModal shareLink={shareLink} contentName={course.Name + " > " + module.Name + " > " + submodule.Name} />, ModalButtons.None);
	};

	// Track window resize to determine mobile state
	useEffect(() => {
		const handleResize = () => {
			const mobile = window.innerWidth < MOBILE_WIDTH;
			setIsMobile(mobile);
			if (!mobile) {
				setExpanded(false);
			}
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	// Close breadcrumb on outside click
	const handleClickOutside = useCallback((e) => {
		if (breadcrumbRef.current && !breadcrumbRef.current.contains(e.target)) {
			setExpanded(false);
		}
	}, []);

	useEffect(() => {
		if (expanded) {
			document.addEventListener("mousedown", handleClickOutside);
		}
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, [expanded, handleClickOutside]);

	useEffect(() => {
		if (breadcrumbRef.current) {
			const height = breadcrumbRef.current.offsetHeight;
			setBreadcrumbHeight(height);
		}
	}, [course, module, submodule, setBreadcrumbHeight, expanded]);

	const mobileClass = isMobile ? "player-breadcrumb--mobile" : "";
	const expandedClass = isMobile && expanded ? "player-breadcrumb--expanded" : "";

	return (
		<div className={`player-breadcrumb ${mobileClass} ${expandedClass}`} ref={breadcrumbRef}>
			<p>
				{course && <Link to={`/course-view#courseId-${course.Id}`}>{course.Name}</Link>}
				{module && <> <FontAwesomeIcon icon={faChevronRight} size='xs' /> <Link to={`/course-view#courseId-${course.Id}-moduleId-${module.Id}`}> {module.Name}</Link></>}
				<span>{submodule && <> <FontAwesomeIcon icon={faChevronRight} size='xs' /> {submodule.Name}</>}</span> 
			</p>
			{isMobile && (
				<button className="player-breadcrumb__toggle" onClick={() => setExpanded(!expanded)} aria-label="Toggle breadcrumb">
					<FontAwesomeIcon icon={faChevronDown} className={`player-breadcrumb__toggle-icon ${expanded ? "player-breadcrumb__toggle-icon--rotated" : ""}`} />
				</button>
			)}
			<Button
				onClick={() => handleOpenShareModal({ shareLink: buildLink() })}
				type={ButtonType.Tertiary}
				text="Share"
				icon={faShareNodes}
			/>
		</div>
	);
};

export default PlayerBreadcrumb;
